import { Menu } from "@headlessui/react";

type DropdownMenuProps = {
    children: React.ReactNode;
};

const DropdownMenu = ({ children }: DropdownMenuProps) => {
    return (
        <Menu as="div" className="relative">
            {children}
        </Menu>
    );
};

export default DropdownMenu;
